import BaseService from '@core/class/BaseService';
import {
  IExportQueryParams,
  IPagination,
  IQueryParams
} from '../../Product/interfaces';

class ReturnServices extends BaseService {
  public getListReturn = ({
    page,
    sort,
    fromDt,
    toDt,
    valueSearch,
    status,
    productName,
    typeAPI,
    returnType
  }: IPagination) => {
    let filter = status ? `&filter.${status}=${valueSearch}` : '';
    let filterStock = productName ? `&filter.status=${productName}` : '';
    let url =
      'api/v1/seller/returns?' +
      `page=${page}&limit=10` +
      `&filter.type=${typeAPI}` +
      `&filter.returnType=${returnType}` +
      filter +
      filterStock;
    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;
    return this.get(url);
  };

  public exportExcelAll = ({
    productName,
    sort,
    fromDt,
    toDt,
    valueSearch,
    status,
    typeAPI,
    returnType,
  }: IPagination) => {
    let url = `api/v1/seller/returns/export-all?&filter.type=${typeAPI}`;
    url +=
      (!!returnType ? `&filter.returnType=${returnType}` : '') +
      (!!productName ? `&filter.status=${productName}` : '') +
      (!!valueSearch && !!status ? `&filter.${status}=${valueSearch}` : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.to=${toDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');

    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportExcelById = (productId: number[]) => {
    let value = 'ids=';
    productId.forEach((item: number) => {
      value = value + item + ',';
    });
    return this.get(
      `api/v1/seller/returns/export?${value.substring(0, value.length - 1)}`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public searchReturns = (query: IQueryParams) => {
    query.limit = 10;
    const searchParams = this.assigneQueryParams(query);

    const url = `api/v1/seller/returns?${searchParams}`;
    return this.get(url);
  };

  public returnExportExcel = (query: IExportQueryParams) => {
    let type = 'export-all';
    if (query.listId && query.listId.length) {
      query = {
        ...query,
        ids: query.listId
      };
      type = 'export';
    } else {
      delete query.listId;
    }

    const searchParams = this.assigneQueryParams(query);
    const url = `api/v1/seller/returns/${type}?${searchParams}`;
    return this.get(
      url,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public getDetailReturn = (productId: number | string) => {
    return this.get(`api/v1/seller/returns/detail/${productId}`);
  };

  public searchOrder = (valueSearch: number | string) => {
    return this.get(
      `api/v1/seller/orders/list-create-request?orderNumber=${
        !!valueSearch ? valueSearch : ''
      }`
    );
  };

  public searchOrderCanReturn = (valueSearch: number | string) => {
    return this.get(
      `api/v1/seller/orders/list-create-return-request?orderNumber=${
        !!valueSearch ? valueSearch : ''
      }`
    );
  };

  public searchQuotation = (valueSearch: number | string) => {
    return this.get(
      `api/v1/seller/imports/list-create-request?id=${
        !!valueSearch ? valueSearch : ''
      }`
    );
  };
  public getListOrderProduct = (productId: number | string) => {
    return this.get(`api/v1/seller/orders/detail/${productId}`);
  };
  public postCreateOrder = (body: Record<string, any>) => {
    return this.post(`api/v1/seller/returns`, body);
  };

  public searchStock = (valueSearch: number | string) => {
    return this.get(
      `api/v1/seller/products/list-create-request?productName=${
        !!valueSearch ? valueSearch : ''
      }`
    );
  };

  public getListStockProduct = (productId: number | string) => {
    return this.get(`api/v1/seller/products/detail/${productId}`);
  };
  public createCommenReturn = (body: Record<string, any>) => {
    return this.post(`api/v1/seller/returns`, body);
  };

  public removeReturn = (returnId: number | string) => {
    return this.delete(`api/v1/seller/returns/${returnId}`);
  }

  public updateReturn = (returnId: number | string, body: Record<string, any>) => {
    return this.patch(`api/v1/seller/returns/${returnId}`, body);
  }
}

export default new ReturnServices('/', true);
